import React, { useEffect, useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import ViewList from "@material-ui/icons/ViewList";

// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import { AmazonConnectPanel } from "layouts/admin/AmazonConnectPanel";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { InactivityTimer } from "./InactivityTimer";
import { ENERSI_ENV, ENERSI_CONF, ENERSI_SERVER, IS_PROD, IS_CRM } from "utils/variables";
import { ThemeToggle } from "components/ThemeToggle/ThemeToggle";

const useStyles = makeStyles(styles);

export default function AdminNavbar(props) {
  const { rules } = useSelector(({ login }) => login)
  const [env, setEnv] = useState('')
  const [isEnvSnackbar, setIsEnvSnackbar] = useState(false)

  const classes = useStyles();
  const { color, rtlActive } = props;

  const appBarClasses = cx({
    [" " + classes[color]]: color,
  });
  const sidebarMinimize =
    classes.sidebarMinimize +
    " gn4-sidebar-minimize " +
    cx({
      [classes.sidebarMinimizeRTL]: rtlActive,
    });

  useEffect(() => {
    setIsEnvSnackbar(!IS_PROD)
    if (IS_CRM)
      setEnv('ENTORNO VOLDEMORT 🌑 🏰')
    else if (!IS_PROD) {
      setEnv(`ENTORNO DE ${ENERSI_ENV} (${ENERSI_CONF} | ${ENERSI_SERVER}) 👩‍💻 🛠️`)
    }
  }, [IS_PROD])

  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown implementation="css">
          <div className={sidebarMinimize} style={{ display: "flex", alignItems: "center", float: "left" }}>
            {props.miniActive ? (
              <Button
                justIcon
                round
                color="white"
                onClick={props.sidebarMinimize}
              >
                <ViewList className={classes.sidebarMiniIcon} />
              </Button>
            ) : (
              <Button
                justIcon
                round
                color="white"
                onClick={props.sidebarMinimize}
              >
                <MoreVert className={classes.sidebarMiniIcon} />
              </Button>
            )}
            <ThemeToggle />
          </div>
        </Hidden>
        <div className={classes.flex} style={{
          paddingTop: 16
        }}>
          {/* Here we create navbar brand, based on route name */}
          {/* <Button href="#" className={classes.title} color="transparent">
            {brandText}
          </Button> */}
          {
            rules.includes('CUSTOMER-CONNECT') && (
              <AmazonConnectPanel />
            )
          }
          {
            isEnvSnackbar
              ?
              <Typography variant="caption" component="p" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'fixed',
                top: 0,
                right: 4,
                backgroundColor: '#F47070',
                color: 'white',
                width: 250,
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
                zIndex: 0,
                textAlign: 'center',
                padding: 8,
                transition: 'all .3s ease'
              }}>
                {env}
                <InactivityTimer />
              </Typography>
              : <Typography variant="caption" component="p" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'fixed',
                top: 0,
                right: 4,
                backgroundColor: '#F47070',
                color: 'white',
                width: 250,
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
                zIndex: 0,
                textAlign: 'center',
                padding: 8,
                transition: 'all .3s ease'
              }}>
                <InactivityTimer />
              </Typography>
          }
        </div>

        <Hidden mdUp implementation="css">
          <div style={{ display: "flex", alignItems: "center" }}>
            <ThemeToggle />
            <Button
              className={classes.appResponsive}
              color="transparent"
              justIcon
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
            >
              <Menu />
            </Button>
          </div>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

AdminNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  brandText: PropTypes.string,
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func,
};
